import { useForm } from 'react-hook-form';
import { Checkbox, FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import { Button, Container, Grid, Paper, Stack, Typography, Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { formatDate, getCurrentDateTime, getKeyPathValue, request, toast } from '../../../../../utils';
import { SAMPLE_COLLECTION_BOOKING_TYPE, COLLECTION_SAMPLE } from '../../../../../constants';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../components';

const calculateAge = (dob, createdAt) => {
  const birthDate = new Date(dob);
  const currentDate = new Date(createdAt);
  let age = currentDate.getFullYear() - birthDate.getFullYear();
  const monthDiff = currentDate.getMonth() - birthDate.getMonth();

  if (monthDiff < 0 || (monthDiff === 0 && currentDate.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
};

const BILL_TABLE_HEADER = [
  {
    header: 'Bill Id',
    accessor: 'bill_no'
  },
  {
    header: 'Date',
    accessor: (row) => `${formatDate(row?.date)}${row.time}` || 'null'
  },
  {
    header: 'Uhid No.',
    accessor: 'uhid'
  },

  {
    header: 'Ipd No.',
    accessor: 'ipd_no'
  },
  {
    header: 'Patient Name',
    accessor: 'patient_name'
  },
  // {
  //   header: 'Age',
  //   accessor: (row) => calculateAge(row.patient.dob, row.createdAt)
  // },
  {
    header: 'Mobile No',
    accessor: 'mobile'
  },
  {
    header: 'Lab Ascession No',
    accessor: 'barcode_no'
  },
  {
    header: 'Lab Bill No',
    accessor: 'bill_no'
  }
];

const TEST_TABLE_HEADER = [
  {
    header: 'Test Name',
    accessor: (row) => row?.test_name?.test_name
  },
  {
    header: 'Quantity',
    accessor: 'quantity'
  },
  {
    header: 'Rate',
    accessor: 'rate'
  },
  {
    header: 'Amount',
    accessor: 'amount'
  },
  {
    header: 'Discount Amount',
    accessor: 'disc_amt'
  },
  {
    header: 'Net Amount',
    accessor: 'net_amt'
  }
];

const initialInvestiagtionBookingDataObj = {
  data: [],
  loading: false
};

export const SampleCollection = () => {
  const [detailList, setDetailList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const [investigationBookingDataObj, setInvestigationBookingDataObj] = useState(initialInvestiagtionBookingDataObj);
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const pathParts = pathname.split('/');
  const organisation = pathParts[1];
  const [collectionSampleFilter, setCollectionSampleFilter] = useState('Pending');
  const [selectedTests, setSelectedTests] = useState([]);
  const [collected, setCollected] = useState(false);
  const user = JSON.parse(localStorage.getItem('user'));

  const [selectedRows, setSelectedRows] = useState([]);

  // Check if a row is selected by looking for its _id in the selectedRows array
  const isSelected = (row) => {
    return row !== undefined && selectedRows.some((selectedRow) => selectedRow._id === row._id);
  };

  const handleRowSelect = (row) => {
    if (row === undefined) {
      console.warn('Row data is undefined. Check data structure.');
      return;
    }
    setSelectedRows((prevSelectedRows) => {
      const isRowAlreadySelected = prevSelectedRows.some((selectedRow) => selectedRow._id === row._id);
      const updatedSelection = isRowAlreadySelected
        ? prevSelectedRows.filter((selectedRow) => selectedRow._id !== row._id)
        : [...prevSelectedRows, row];

      console.log('selectedRows has changed:', updatedSelection);
      return updatedSelection;
    });
  };

  useEffect(() => {
    console.log('selectedRows has changed:', selectedRows);
  }, [selectedRows]);

  const methods = useForm({
    resolver: yupResolver(Yup.object().shape({})),
    defaultValues: {
      date: getCurrentDateTime('date'),
      time: getCurrentDateTime('time'),
      bill: {
        out_sourced: 'No',
        rec_amt_1: 0,
        rec_amt_2: 0,
        tds_amt: 0,
        disc_amt: 0,
        gst_amt: 0,
        net_amt: 0
      }
    },
    mode: 'all'
  });
  const { handleSubmit, reset, setValue } = methods;

  useEffect(() => {
    if (selectedRecord) {
      const keyValuePair = getKeyPathValue(selectedRecord, 'bill', [
        '__v',
        '_id',
        'createdAt',
        'status',
        'service_items',
        'uhid'
      ]);
      keyValuePair.forEach(({ key, value }) => setValue(key, value));
      setValue('uhid', selectedRecord.uhid);
      setDetailList(selectedRecord.service_items.filter((item) => item.sample_collected === false));
      setValue('date', getCurrentDateTime('date', selectedRecord.createdAt));
      setValue('time', getCurrentDateTime('time', selectedRecord.createdAt));
    } else {
      reset();
    }
  }, [selectedRecord]);

  const formSubmit = async (formValues) => {
    const cleanedServiceItems = selectedRows.map(({ _id, ...rest }) => rest);
    setLoading(true);
    const payload = {
      uhid: formValues.uhid,
      service_items: cleanedServiceItems,
      bill_no: selectedRecord.bill_no,
      createdAt: selectedRecord.createdAt,
      ipd_no: selectedRecord.ipd_no || '',
      patient_name: selectedRecord.patient_name,
      age: selectedRecord.age,
      gender: selectedRecord.gender,
      doctor: selectedRecord.doctor,
      mobile_no: selectedRecord.mobile,
      barcode_no: selectedRecord.barcode_no,
      lab_bill_no: selectedRecord.bill_no
    };
    let editFlag = false;
    if (selectedRecord && currentAction === 'edit') {
      editFlag = true;
    }
    const response = await request(editFlag ? '/lis-sample-collection-edit' : '/lis-sample-collection-create', {
      method: editFlag ? 'PUT' : 'POST',
      params: editFlag ? selectedRecord._id : null,
      body: {
        ...payload,
        createdBy: user.name,
        updatedBy: editFlag ? user.name : '',
        organisation
      }
    });
    if (response?.success) {
      toast(`Successfully ${editFlag ? 'edited' : 'created'} Sample Collected `, { variant: 'success' });
      setSelectedRecord(response.data);
      setCurrentAction();
      fetchData();
      window.location.reload();
    } else {
      toast(`Failed to ${editFlag ? 'edit' : 'create'} Sample Collection`, { variant: 'error' });
    }
    setLoading(false);
    console.log('Form values:', formValues);
  };

  const handleRowDelete = (rowId) => {
    setDetailList((prev) => prev.filter((data) => data.id !== rowId));
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await request('/investigation-booking-list', { method: 'GET' });
      if (response.success) {
        const fromDate = methods.getValues('from_date');
        const toDate = methods.getValues('to_date');
        const filteredData = filterData(response.data, collectionSampleFilter, fromDate, toDate);
        setInvestigationBookingDataObj({ loading: false, data: filteredData });
      } else {
        toast('Error in fetching data', { variant: 'error' });
        setInvestigationBookingDataObj({ loading: false });
      }
    } catch (error) {
      toast('Error in fetching data', { variant: 'error' });
      setInvestigationBookingDataObj({ loading: false });
    }
  };

  const filterData = (data, filter, fromDate, toDate) => {
    let filteredData = [...data];
    if (filter === 'Pending') {
      filteredData = filteredData.filter((item) => {
        // Show Pending if any of the services has sample_collected = false
        return item.service_items.some((service) => !service.sample_collected);
      });
    } else if (filter === 'Collected') {
      filteredData = filteredData.filter((item) => {
        // Show Collected if all services have sample_collected = true
        return item.service_items.every((service) => service.sample_collected);
      });
    }

    // Date filtering
    if (fromDate && toDate) {
      const from = new Date(fromDate).setHours(0, 0, 0, 0);
      const to = new Date(toDate).setHours(23, 59, 59, 999);

      filteredData = filteredData.filter((item) => {
        const createdAt = new Date(item.createdAt).getTime();
        return createdAt >= from && createdAt <= to;
      });
    }

    return filteredData;
  };

  useEffect(() => {
    fetchData();
  }, [collectionSampleFilter, methods.watch('from_date'), methods.watch('to_date')]);

  const handleCollected = () => {};

  const handleRowClick = (row) => {
    setSelectedTests((prevSelectedTests) => {
      const newSelectedTests = [...prevSelectedTests, row];
      console.log('Updated selected tests: ', newSelectedTests);
      return newSelectedTests;
    });
  };

  return (
    <>
      <Paper sx={{ p: 0, flex: 1, borderRadius: 0, boxShadow: 'none' }}>
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 700 }}>
                Sample Collection
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <CustomButtonn id={'Submit'} type="submit" variant="contained" onClick={handleSubmit(formSubmit)}>
                  Collection Sample
                </CustomButtonn>
                <CustomButtonn id={`${lastPathSegment}Print`} variant="contained">
                  Collect & Print
                </CustomButtonn>
                <CustomButtonn id={`${lastPathSegment}Print`} variant="contained">
                  Print
                </CustomButtonn>
                <CustomButtonn id={`${lastPathSegment}Print`} variant="contained">
                  TRF Print
                </CustomButtonn>
                <CustomButtonn id={'Exit'} variant="contained">
                  Exit
                </CustomButtonn>
              </Stack>
            </Stack>
            <Box
              sx={{
                border: '0px solid gray',
                padding: 2,
                borderRadius: '8px',
                width: '100%',
                boxShadow: '0px 2px 10px #0099ff'
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={5} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.35, fontWeight: 700, fontSize: '1.4rem' }}>Collection Sample</Typography>
                    <SelectTag
                      formControlSX={{ flex: 0.8 }}
                      name="collection_sample"
                      menus={COLLECTION_SAMPLE}
                      defaultValue="Pending"
                      onChange={(e) => setCollectionSampleFilter(e.target.value)}
                    />
                  </Stack>
                </Grid>
                <Grid item xs={5} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>From Date</Typography>
                    <TextField sx={{ flex: 0.5 }} name="from_date" type="date" />
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>To Date</Typography>
                    <TextField sx={{ flex: 0.5 }} name="to_date" type="date" />
                  </Stack>
                </Grid>
                <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                  <Stack spacing={1} direction="row" justifyContent="space-between"></Stack>
                  <Grid
                    item
                    xs={12}
                    sx={{ display: 'flex', flexDirection: 'column', gap: 0.3, boxShadow: '0px 2px 2px #0099ff' }}
                  >
                    <Table
                      containerSX={{ flex: 1, border: '0px solid rgba(0,0,0,0.27)' }}
                      data={investigationBookingDataObj.data}
                      columns={BILL_TABLE_HEADER}
                      size="small"
                      onRowClick={(row) => {
                        setSelectedRecord(row);
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid
                item
                xs={12}
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 0.3,
                  marginTop: '10px',
                  boxShadow: '0px 2px 2px #0099ff'
                }}
              >
                <Table
                  containerSX={{ flex: 1, border: '0px solid rgba(0,0,0,0.27)' }}
                  data={detailList.map((data) => ({ _id: data.service, ...data }))}
                  columns={TEST_TABLE_HEADER}
                  size="small"
                  showCollected={true}
                  handleRowSelect={handleRowSelect}
                  isSelected={isSelected}
                />
              </Grid>
            </Box>
          </FormProvider>
        </Container>
      </Paper>
    </>
  );
};
